// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"8b30cff0","256":"78617384","753":"4d1daee9","935":"bdebd055"}[chunkId] + ".chunk.css";
};